var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "vue__filter-container",
      class: { vue__loading: _vm.filters.loadingFilters }
    },
    [
      _vm.filters.loadingFilters
        ? _c("div", { staticClass: "vue__loader" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "vue__mobile-filter-toggle",
          on: {
            click: function($event) {
              return _vm.openFilterBlock("mobile_toggle")
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "vue__filter-title-container",
              class: {
                "vue__filter-title-container--open":
                  _vm.filterVisibility["mobile_toggle"]
              }
            },
            [
              _c("h5", { staticClass: "vue__filter-title" }, [
                _vm._v(_vm._s(_vm.filtersLabel))
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "vue__filters",
          class: { "vue__filters--open": _vm.filterVisibility["mobile_toggle"] }
        },
        [
          _vm.resetFilterState
            ? _c(
                "div",
                {
                  staticClass:
                    "vue__filter-block vue__filter-block--search-reset"
                },
                [
                  _c(
                    "h5",
                    {
                      staticClass: "vue__filter-title vue__filter-title--reset",
                      on: {
                        click: function($event) {
                          return _vm.resetFilters()
                        }
                      }
                    },
                    [_vm._m(0), _vm._v(_vm._s(_vm.resetLabel))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.postType == "catalogus"
            ? _c("div", { staticClass: "vue__filter-block" }, [
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-title-container",
                    class: {
                      "vue__filter-title-container--open":
                        _vm.filterVisibility["product_search"]
                    },
                    on: {
                      click: function($event) {
                        return _vm.openFilterBlock("product_search")
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "vue__filter-title" }, [
                      _vm._v(_vm._s(_vm.searchLabel))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "vue__text-container",
                    class: {
                      "vue__text-container--open":
                        _vm.filterVisibility["product_search"]
                    }
                  },
                  [
                    _c("form", { staticClass: "vue__text-inner" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settedFilters.productTextSearch,
                            expression: "settedFilters.productTextSearch"
                          }
                        ],
                        attrs: { type: "text", placeholder: _vm.searchLabel },
                        domProps: {
                          value: _vm.settedFilters.productTextSearch
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.settedFilters,
                              "productTextSearch",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.generateUrlParameters($event)
                            },
                            blur: function($event) {
                              return _vm.generateUrlParameters($event)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "20",
                                height: "20",
                                xmlns: "http://www.w3.org/2000/svg"
                              }
                            },
                            [
                              _c("defs", [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M20 18.586L18.586 20l-4.243-4.242 1.414-1.415L20 18.586zM8 14c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.309-2.692 6-6 6zM8 0a8 8 0 100 16A8 8 0 008 0z",
                                    id: "a"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    "fill-rule": "evenodd"
                                  }
                                },
                                [
                                  _c(
                                    "mask",
                                    { attrs: { id: "b", fill: "#fff" } },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#a" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("use", {
                                    attrs: { fill: "#000", "xlink:href": "#a" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        mask: "url(#b)",
                                        fill: "#6F6F6F"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: { d: "M-2-2h24v24H-2z" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.filters.productRadio, function(radio) {
            return _c(
              "div",
              {
                staticClass: "vue__filter-block",
                style: { order: radio.order }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-title-container",
                    class: {
                      "vue__filter-title-container--open":
                        _vm.filterVisibility[radio.visibilityName]
                    },
                    on: {
                      click: function($event) {
                        return _vm.openFilterBlock(radio.visibilityName)
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "vue__filter-title" }, [
                      _vm._v(_vm._s(radio.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "vue__filter-items",
                    class: {
                      "vue__filter-items--open":
                        _vm.filterVisibility[radio.visibilityName]
                    }
                  },
                  [
                    _c("li", { staticClass: "vue__filter-item" }, [
                      _c("div", { staticClass: "vue__checkbox-container" }, [
                        _c(
                          "label",
                          {
                            staticClass: "vue__checkbox vue__checkbox--radio",
                            attrs: { for: "all" }
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "all",
                                name: radio.name,
                                type: "radio",
                                value: "all",
                                checked: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changeCheckbox(
                                    "",
                                    "radio",
                                    radio.name
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "vue__checker" }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "vue__checkbox-label vue__checkbox-label--capitalize"
                              },
                              [_vm._v(_vm._s(radio.firstLabel))]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(radio.items, function(item) {
                      return _c("li", { staticClass: "vue__filter-item" }, [
                        _c("div", { staticClass: "vue__checkbox-container" }, [
                          _c(
                            "label",
                            {
                              staticClass: "vue__checkbox vue__checkbox--radio",
                              attrs: { for: item.name }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: item.name,
                                  name: radio.name,
                                  type: "radio"
                                },
                                domProps: { value: item.name },
                                on: {
                                  change: function($event) {
                                    return _vm.changeCheckbox(
                                      item.name,
                                      "radio",
                                      radio.name
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "vue__checker" }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "vue__checkbox-label vue__checkbox-label--capitalize"
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            ]
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.filters.productTaxonomiesCheckbox, function(taxonomy) {
            return _c(
              "div",
              {
                staticClass: "vue__filter-block",
                style: { order: taxonomy.order }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-title-container",
                    class: {
                      "vue__filter-title-container--open":
                        _vm.filterVisibility[taxonomy.visibilityName]
                    },
                    on: {
                      click: function($event) {
                        return _vm.openFilterBlock(taxonomy.visibilityName)
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "vue__filter-title" }, [
                      _vm._v(_vm._s(taxonomy.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "vue__filter-items",
                    class: {
                      "vue__filter-items--open":
                        _vm.filterVisibility[taxonomy.visibilityName]
                    }
                  },
                  _vm._l(taxonomy.items, function(item) {
                    return _c("li", { staticClass: "vue__filter-item" }, [
                      _c("div", { staticClass: "vue__checkbox-container" }, [
                        _c("label", { staticClass: "vue__checkbox" }, [
                          _c("input", {
                            attrs: { type: "checkbox", id: item.id },
                            domProps: { value: item.id },
                            on: {
                              change: function($event) {
                                return _vm.changeCheckbox(
                                  item.id,
                                  "taxonomy",
                                  taxonomy.name
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "vue__checker" }),
                          _vm._v(" "),
                          _c("p", { staticClass: "vue__checkbox-label" }, [
                            _vm._v(_vm._s(item.name))
                          ])
                        ])
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.filters.productTaxonomiesDropdown, function(taxonomy) {
            return _c(
              "div",
              {
                staticClass: "vue__filter-block",
                style: { order: taxonomy.order }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-title-container",
                    class: {
                      "vue__filter-title-container--open":
                        _vm.filterVisibility[taxonomy.visibilityName]
                    },
                    on: {
                      click: function($event) {
                        return _vm.openFilterBlock(taxonomy.visibilityName)
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "vue__filter-title" }, [
                      _vm._v(_vm._s(taxonomy.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-select-container",
                    class: {
                      "vue__filter-select-container--open":
                        _vm.filterVisibility[taxonomy.visibilityName]
                    }
                  },
                  [
                    _c(
                      "select",
                      {
                        staticClass: "vue__filter-select",
                        attrs: { id: taxonomy.name },
                        on: {
                          change: function($event) {
                            return _vm.changeDropdown(
                              $event,
                              "taxonomy",
                              taxonomy.name
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { selected: "", value: "0" } }, [
                          _vm._v(_vm._s(taxonomy.firstLabel))
                        ]),
                        _vm._v(" "),
                        _vm._l(taxonomy.items, function(item) {
                          return _c(
                            "option",
                            {
                              attrs: { id: item.id },
                              domProps: { value: item.id }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.name) +
                                  "\n                    "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.filters.ranges, function(range, index) {
            return _c(
              "div",
              {
                staticClass: "vue__filter-block",
                style: { order: range.order }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-title-container",
                    class: {
                      "vue__filter-title-container--open":
                        _vm.filterVisibility[range.name]
                    },
                    on: {
                      click: function($event) {
                        return _vm.openFilterBlock(range.name)
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "vue__filter-title" }, [
                      _vm._v(_vm._s(range.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "vue__filter-range",
                    class: {
                      "vue__filter-range--open":
                        _vm.filterVisibility[range.name]
                    }
                  },
                  [
                    _c("form", { staticClass: "vue__filter-range-inner" }, [
                      _c("p", { staticClass: "vue__filter-prefix" }, [
                        _vm._v(_vm._s(range.prefix))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: range.min_value,
                            expression: "range.min_value"
                          }
                        ],
                        attrs: {
                          id: "vue__range-min-" + index,
                          type: "number"
                        },
                        domProps: { value: range.min_value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(range, "min_value", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "vue__filter-between" }, [
                        _vm._v("Tot")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: range.max_value,
                            expression: "range.max_value"
                          }
                        ],
                        attrs: {
                          id: "vue__range-max-" + index,
                          type: "number"
                        },
                        domProps: { value: range.max_value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(range, "max_value", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "vue__filter-range-submit",
                        attrs: { "data-id": index },
                        on: {
                          click: function($event) {
                            return _vm.generateUrlParameters($event, index)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vue__filter-range-slider" }, [
                      _c("div", {
                        attrs: {
                          id: "vue__range-slider-" + index,
                          "data-min": range.min_value,
                          "data-max": range.max_value
                        }
                      })
                    ])
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.filters.allExternalProjectFilters, function(filterBlock) {
            return _c("div", { staticClass: "vue__filter-block" }, [
              _c(
                "div",
                {
                  staticClass: "vue__filter-title-container",
                  class: {
                    "vue__filter-title-container--open":
                      _vm.filterVisibility[filterBlock.slug]
                  },
                  on: {
                    click: function($event) {
                      return _vm.openFilterBlock(filterBlock.slug)
                    }
                  }
                },
                [
                  _c("h5", { staticClass: "vue__filter-title" }, [
                    _vm._v(_vm._s(filterBlock.name))
                  ])
                ]
              ),
              _vm._v(" "),
              filterBlock.type == "text"
                ? _c(
                    "div",
                    {
                      staticClass: "vue__text-container",
                      class: {
                        "vue__text-container--open":
                          _vm.filterVisibility[filterBlock.slug]
                      }
                    },
                    [
                      _c("form", { staticClass: "vue__text-inner" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: filterBlock.value,
                              expression: "filterBlock.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: filterBlock.name
                          },
                          domProps: { value: filterBlock.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                filterBlock,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                return _vm.generateUrlParameters($event)
                              },
                              blur: function($event) {
                                return _vm.generateUrlParameters($event)
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              },
                              [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M20 18.586L18.586 20l-4.243-4.242 1.414-1.415L20 18.586zM8 14c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.309-2.692 6-6 6zM8 0a8 8 0 100 16A8 8 0 008 0z",
                                      id: "a"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c(
                                      "mask",
                                      { attrs: { id: "b", fill: "#fff" } },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#a" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("use", {
                                      attrs: {
                                        fill: "#000",
                                        "xlink:href": "#a"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          mask: "url(#b)",
                                          fill: "#6F6F6F"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: { d: "M-2-2h24v24H-2z" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              filterBlock.type == "radio"
                ? _c(
                    "ul",
                    {
                      staticClass: "vue__filter-items",
                      class: {
                        "vue__filter-items--open":
                          _vm.filterVisibility[filterBlock.slug]
                      }
                    },
                    [
                      _c("li", { staticClass: "vue__filter-item" }, [
                        _c("div", { staticClass: "vue__checkbox-container" }, [
                          _c(
                            "label",
                            {
                              staticClass: "vue__checkbox vue__checkbox--radio",
                              attrs: { for: "all" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: filterBlock.checked,
                                    expression: "filterBlock.checked"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "all",
                                  name: filterBlock.slug,
                                  value: "all",
                                  checked: ""
                                },
                                domProps: {
                                  checked: _vm._q(filterBlock.checked, "all")
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(
                                        filterBlock,
                                        "checked",
                                        "all"
                                      )
                                    },
                                    function($event) {
                                      return _vm.generateUrlParameters()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "vue__checker" }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "vue__checkbox-label vue__checkbox-label--capitalize"
                                },
                                [_vm._v("All")]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(filterBlock.items, function(item) {
                        return _c("li", { staticClass: "vue__filter-item" }, [
                          _c(
                            "div",
                            { staticClass: "vue__checkbox-container" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "vue__checkbox vue__checkbox--radio",
                                  attrs: { for: item.value }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: filterBlock.checked,
                                        expression: "filterBlock.checked"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: item.value,
                                      name: filterBlock.slug
                                    },
                                    domProps: {
                                      value: item.value,
                                      checked: _vm._q(
                                        filterBlock.checked,
                                        item.value
                                      )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          return _vm.$set(
                                            filterBlock,
                                            "checked",
                                            item.value
                                          )
                                        },
                                        function($event) {
                                          return _vm.generateUrlParameters()
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "vue__checker" }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "vue__checkbox-label vue__checkbox-label--capitalize"
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              filterBlock.type == "checkbox"
                ? _c(
                    "ul",
                    {
                      staticClass: "vue__filter-items",
                      class: {
                        "vue__filter-items--open":
                          _vm.filterVisibility[filterBlock.slug]
                      }
                    },
                    _vm._l(filterBlock.items, function(item) {
                      return _c("li", { staticClass: "vue__filter-item" }, [
                        _c("div", { staticClass: "vue__checkbox-container" }, [
                          _c("label", { staticClass: "vue__checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.checked,
                                  expression: "item.checked"
                                }
                              ],
                              attrs: { type: "checkbox", id: item.slug },
                              domProps: {
                                value: item.slug,
                                checked: Array.isArray(item.checked)
                                  ? _vm._i(item.checked, item.slug) > -1
                                  : item.checked
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = item.checked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = item.slug,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "checked",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "checked",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "checked", $$c)
                                    }
                                  },
                                  function($event) {
                                    return _vm.generateUrlParameters()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "vue__checker" }),
                            _vm._v(" "),
                            _c("p", { staticClass: "vue__checkbox-label" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ])
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              filterBlock.type == "dropdown"
                ? _c(
                    "div",
                    {
                      staticClass: "vue__filter-select-container",
                      class: {
                        "vue__filter-select-container--open":
                          _vm.filterVisibility[filterBlock.slug]
                      }
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: filterBlock.selected,
                              expression: "filterBlock.selected"
                            }
                          ],
                          staticClass: "vue__filter-select",
                          attrs: { id: filterBlock.slug },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  filterBlock,
                                  "selected",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.generateUrlParameters()
                              }
                            ]
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { selected: "", value: "0" } },
                            [_vm._v(_vm._s(filterBlock.placeholder))]
                          ),
                          _vm._v(" "),
                          _vm._l(filterBlock.items, function(item) {
                            return _c(
                              "option",
                              {
                                attrs: { id: item.value },
                                domProps: { value: item.value }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.name) +
                                    "\n                    "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "vue__reset" }, [
      _c("span", { staticClass: "vue__cross" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }